import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DatePipe, getCurrencySymbol} from '@angular/common';
import {User} from '../../services/user/user';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {ShipmentReviewService} from '../../services/shipment-review/shipment-review.service';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import {Router} from '@angular/router';
import * as Constants from '../../shared/common-components/AppConstants';
import {takeWhile} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import AppConstants from '../../shared/common-components/AppConstants';

@Component({
    selector: 'app-shipment-review',
    templateUrl: './shipment-review.component.html',
    styleUrls: ['./shipment-review.component.css'],
    providers: [DatePipe],
    standalone: false
})

export class ShipmentReviewComponent implements OnInit, OnDestroy {

  shipmentReviewGridOptions: GridOptions = this.initializeGridOptions();
  shipmentReviewListBeforeEditFields: any = [];
  shipmentReviewList: any = [];
  currentUser: User;
  haveRecords = false;
  errorMessage = '';
  shipmentType = '';
  status = '';
  isFromHHGShipment: boolean;
  isFromFRTShipment: boolean;
  frameworkComponents: any;
  private tmssloader;
  orgId: number;
  carrierId: number;
  private observer$ = new BehaviorSubject(true);
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;

  shipmentReviewForm: UntypedFormGroup;
  statuses: string[] = ['Accepted', 'Accepted with Qualification', 'Booked', 'Cancelled', 'Complete', 'Expired', 'Incomplete', 'Modified',
    'Pending', 'Refused'];
  statusesTsp: string[] = ['Accepted', 'Accepted with Qualification', 'Booked', 'Cancelled', 'Complete', 'Expired', 'Modified',
    'Pending', 'Refused'];  
  carrierUser: boolean;

  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private route: ActivatedRoute,
              public datePipe: DatePipe,
              private userService: UserService,
              private shipmentReviewService: ShipmentReviewService,
              private router: Router
  ) {
    this.tmssloader = this.loader;
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
      if (AppConstants.isNotNullCondition(this.currentUser)) {
        if (this.currentUser.roles[0].name === this.agency_admin || this.currentUser.roles[0].name === this.agency_user) {
          this.orgId = this.currentUser.organizationId;
        } else {
          this.orgId = -1;
        }
      } else {
        this.orgId = -1;
      }
      if (this.currentUser.carrierId !== null){
        this.carrierUser = true;
        this.carrierId = this.currentUser.carrierId;
      } else {
        this.carrierUser = false;
        this.carrierId = -1;
      }
    });
    this.shipmentReviewForm = this.fb.group({
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit(): void {
    this.shipmentReviewGridOptions.columnDefs = this.getShipmentReviewColumnDefs();
    if (this.router.url.indexOf('frt') !== -1) {
      this.shipmentType = 'FRT';
/*      this.isFromFRTShipment = true;
      this.isFromHHGShipment = false;*/
      this.shipmentReviewGridOptions.columnDefs.push({
        headerName: 'OTO',
        field: 'oneTimeOnly',
        width: 80,
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Actual Delivery Date',
        field: 'actualDeliveryDate',
        width: 120,
        filter: 'agDateColumnFilter'
      },
      {
        headerName: 'Sent To Syncada',
        field: 'sentToSyncada',
        width: 100,
        filter: 'agTextColumnFilter' 
      },
      {
        headerName: 'Date Sent to Syncada',
        field: 'dateSentToSyncada',
        width: 120,
        filter: 'agDateColumnFilter'
      });
    } else if (this.router.url.indexOf('hhg') !== -1) {
      this.shipmentType = 'HHG';
/*      this.isFromHHGShipment = true;
      this.isFromFRTShipment = false;*/
      this.shipmentReviewGridOptions.columnDefs.push({
        headerName: 'Last Name',
        field: 'movingEmpLastName',
        filter: 'agTextColumnFilter'
      });
    } else {
      this.alertService.error('Unspecified shipment type');
    }
    this.getShipmentReviewList(this.shipmentType, this.status ? this.status : 'All');
    this.shipmentReviewForm.get('status').valueChanges.
    pipe(takeWhile(() => this.observer$.value))
      .subscribe(status => {
      this.status = status ? status : 'All';
      this.getShipmentReviewList(this.shipmentType, this.status);
    });
    window.scrollTo(0, 0);
  }

  isFormElementInValid(fullFormControlName: string) {
    const fromElement = this.shipmentReviewForm.get(fullFormControlName);
    return fromElement && fromElement.invalid &&
      fromElement.touched;
  }
  refreshTableandStatus(){
    this.getShipmentReviewList(this.shipmentType, "All");
    this.shipmentReviewForm.get('status').setValue("");
  }
  // Get the Shipment Review records for a provided shipmentType
  getShipmentReviewList(shipmentType: string, status: string) {
    this.shipmentReviewListBeforeEditFields = [];
    this.shipmentReviewList = [];
    this.tmssloader.show();
    this.shipmentReviewService.getShipmentReviewListByShipmentType(shipmentType, status, this.orgId, this.carrierId)
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(data => {
        if (data) {
          this.shipmentReviewListBeforeEditFields = data;
          this.tmssloader.hide();
          if (this.shipmentReviewListBeforeEditFields.length > 0) {
            this.haveRecords = true;
            this.errorMessage = '';
            for (const shipmentReviewDetails of this.shipmentReviewListBeforeEditFields) {
              if (shipmentReviewDetails.originCountry === 'UNITED STATES') {
                shipmentReviewDetails.origin = shipmentReviewDetails.originCity + ', '
                  + shipmentReviewDetails.originState + '(' + shipmentReviewDetails.originZip + ')';
              }
              if (shipmentReviewDetails.originCountry !== 'UNITED STATES') {
                shipmentReviewDetails.origin = shipmentReviewDetails.originCountry;
              }
              if (shipmentReviewDetails.destContry === 'UNITED STATES') {
                shipmentReviewDetails.destination = shipmentReviewDetails.destCity + ', '
                  + shipmentReviewDetails.destState + '(' + shipmentReviewDetails.destZip + ')';
              }
              if (shipmentReviewDetails.destContry !== 'UNITED STATES') {
                shipmentReviewDetails.destination = shipmentReviewDetails.destContry;
              }
              if (null != shipmentReviewDetails.moveDate && shipmentReviewDetails.moveDate.length > 0) {
                shipmentReviewDetails.moveDate = this.datePipe.transform(shipmentReviewDetails.moveDate, 'MM/dd/yyyy');
              }
              if (null != shipmentReviewDetails.actualDeliveryDate && shipmentReviewDetails.actualDeliveryDate.length > 0) {
                shipmentReviewDetails.actualDeliveryDate = this.datePipe.transform(shipmentReviewDetails.actualDeliveryDate, 'MM/dd/yyyy');
              }
              if (null != shipmentReviewDetails.dateSentToSyncada && shipmentReviewDetails.dateSentToSyncada.length > 0) {
                shipmentReviewDetails.dateSentToSyncada = this.datePipe.transform(shipmentReviewDetails.dateSentToSyncada, 'MM/dd/yyyy');
              }
            }
          }
          if (this.shipmentReviewListBeforeEditFields.length === 0) {
            this.errorMessage = 'No records found for the search criteria!!!!!! ';
          }
        }
        this.tmssloader.hide();
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('There was an error retrieving Shipment Review records');
      });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      rowHeight: 40,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  getShipmentReviewColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'Shipment ID',
          field: 'shipmentId',
          filter: 'agNumberColumnFilter',
          width: 90,
          cellRenderer: params => {
            if (null != params.data.bolNumber || params.data.bolNumber) {
              return params.data.shipmentId;
            }
            return '<a tabindex="0">' + params.data.shipmentId + '</a>';
          },
          onCellClicked: event => this.onShipmentIdClicked(event.data)
        },
      {
        headerName: 'BOL Number',
        field: 'bolNumber',
        width: 100,
        filter: 'agTextColumnFilter',
        cellRenderer: params => {
          if (null != params.data.bolNumber || params.data.bolNumber) {
            return '<a tabindex="0">' + params.data.bolNumber + '</a>';
          }
        },
        onCellClicked: event => this.onShipmentIdClicked(event.data)
      },
      {
        headerName: 'TSP',
        field: 'carrierName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Origin',
        field: 'origin',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination',
        field: 'destination',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Move Date',
        field: 'moveDate',
        width: 120,
        filter: 'agDateColumnFilter'
      },
      {
        headerName: 'Status',
        width: 130,
        field: 'bookingStatus',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Total Cost',
        width: 90,
        field: 'totalCost',
        filter: 'agTextColumnFilter',
        valueFormatter: this.shipmentReviewService.formatNumber
      },
      {
        headerName: 'IFF Calculated',
        width: 90,
        field: 'estimatedIffDue',
        filter: 'agTextColumnFilter',
        valueFormatter: this.shipmentReviewService.formatNumber
      },
      {
        headerName: 'Weight',
        width: 90,
        field: 'weight',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Miles',
        width: 90,
        field: 'miles',
        filter: 'agTextColumnFilter'
      }
    ];
  }


  /**
   * sorting the data
   * @param sortModel
   * @param data
   */
  sortData(sortModel, data) {
    const sortPresent = sortModel && sortModel.length > 0;
    if (!sortPresent) {
      return data;
    }
    const resultOfSort = data.slice();
    resultOfSort.sort(function (a, b) {
      for (let k = 0; k < sortModel.length; k++) {
        const sortColModel = sortModel[k];
        const valueA = a[sortColModel.colId];
        const valueB = b[sortColModel.colId];
        if (valueA === valueB) {
          continue;
        }
        const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
        if (valueA > valueB) {
          return sortDirection;
        } else {
          return sortDirection * -1;
        }
      }
      return 0;
    });
    return resultOfSort;
  }

  /**
   * filtering the data
   * @param filterModel
   * @param data
   */
  filterData(filterModel, data) {
    const filterPresent = filterModel && Object.keys(filterModel).length > 0;
    if (!filterPresent) {
      return data;
    }
    const resultOfFilter = [];
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      if (filterModel.updateFlag) {
        if (filterModel.updateFlag.filter.toUpperCase().indexOf(item.updateFlag.toString().toUpperCase()) < 0) {
          continue;
        }
      }
      if (filterModel.destinationType) {
        if (filterModel.destinationType.filter.toUpperCase().indexOf(item.destinationType.toString().toUpperCase()) < 0) {
          continue;
        }
      }
      resultOfFilter.push(item);
    }
    return resultOfFilter;
  }

  onShipmentIdClicked(shipmentReviewListSelectedItem: any) {
    this.router.navigate(['/', 'shipmentcontrolreview'],
      {queryParams: {bookshipmentid: shipmentReviewListSelectedItem.shipmentId, shipmentType: this.shipmentType}});
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }
}
